import {
  $acceptInvite,
  $addTeamMembers,
  $deleteTeamMembers,
  $downgradeToUser,
  $freezeTeamMembers,
  $getTeamMembers,
  $unfreezeTeamMembers,
  $upgradeToAdmin,
  acceptInvite,
  addTeamMembers,
  deleteTeamMembers,
  downgradeToUser,
  finishInviteAccepting,
  freezeTeamMembers,
  getTeamMembers,
  initInviteAccepting,
  unfreezeTeamMembers,
  upgradeToAdmin,
} from './actionCreators';
import reducer from './reducer';
import sagas from './sagas';

export default {
  sagas,
  reducer,
  actions: {
    finishInviteAccepting,
    acceptInvite,
    initInviteAccepting,
    addTeamMembers,
    deleteTeamMembers,
    getTeamMembers,
    upgradeToAdmin,
    downgradeToUser,
    freezeTeamMembers,
    unfreezeTeamMembers,
  },
};

export const $actions = {
  addTeamMembers: $addTeamMembers,
  acceptInvite: $acceptInvite,
  deleteTeamMembers: $deleteTeamMembers,
  getTeamMembers: $getTeamMembers,
  upgradeToAdmin: $upgradeToAdmin,
  downgradeToUser: $downgradeToUser,
  freezeTeamMembers: $freezeTeamMembers,
  unfreezeTeamMembers: $unfreezeTeamMembers,
};
